// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"fd3c1c25","488":"afae63cb"}[chunkId] + ".chunk.js";
};